export const getProduct = ({ products }, sku) => {
  return products.filter(p => p.sku === sku)[0] || {}
}



// WEBPACK FOOTER //
// ./src/features/Availability/SearchCard/selector.js